var s=function(s,i){this.pollId=0,this.messageId=0,this.pollId=i.poll.id,this.messageId=i.poll.message_id,this._iid=s,this._payload=i};export{s as P};
